var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "questionId",
                    label: "题目ID",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入题目ID" },
                    model: {
                      value: _vm.model.questionId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "questionId", $$v)
                      },
                      expression: "model.questionId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "optionsId",
                    label: "选项ID",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入选项ID" },
                    model: {
                      value: _vm.model.optionsId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "optionsId", $$v)
                      },
                      expression: "model.optionsId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "value",
                    label: "其他内容",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入其他内容" },
                    model: {
                      value: _vm.model.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "value", $$v)
                      },
                      expression: "model.value",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "studentId",
                    label: "学生id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入学生id" },
                    model: {
                      value: _vm.model.studentId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "studentId", $$v)
                      },
                      expression: "model.studentId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "classId",
                    label: "班级id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入班级id" },
                    model: {
                      value: _vm.model.classId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "classId", $$v)
                      },
                      expression: "model.classId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "tenantId",
                    label: "租户ID",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.tenantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "tenantId", $$v)
                      },
                      expression: "model.tenantId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }